export default "__VITE_ASSET__CAv3uyHO__"